import { useTranslation } from 'react-i18next';

import type { NumberingSeries } from '~/types/user';

import { useDeleteNumberingSeries } from '~/api/numberingSeries';
import { AlertDialog, Button } from '~/components';
import { toast } from '~/utils/toast';

type Props = {
  numberingSeries: NumberingSeries;
  onClose: () => void;
};

export const ConfirmDeleteNumberingSeriesDialog = ({ numberingSeries, onClose }: Props) => {
  const mutation = useDeleteNumberingSeries(numberingSeries.id);

  const { t } = useTranslation(['common', 'settings']);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('settings:general.numberingSeries.delete.title')}</AlertDialog.Title>

      <AlertDialog.Description>
        {t('settings:general.numberingSeries.delete.description', { numberingSeries: numberingSeries.name })}
      </AlertDialog.Description>

      <AlertDialog.Actions>
        <Button
          emphasis="status"
          icon="Trash"
          loading={mutation.isPending}
          onClick={() =>
            mutation.mutate(undefined, {
              onSuccess: () => {
                onClose();
                toast.success({ description: t('settings:alerts.numberingSeries.successDeleted') });
              },
              onError: () => toast.danger({ description: t('common:error') }),
            })
          }
        >
          {t('common:actions.delete')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
